import LocalFlorist from "@material-ui/icons/LocalFlorist";
import SupervisedUserCircle from "@material-ui/icons/SupervisedUserCircle";

const corporateValuesList = [
  {
    title: "Enfocados en el Turismo Rural",
    icon: LocalFlorist,
    description: `Tenemos como principal rumbo promover los servicios que conforman el Turismo
    Rural y sus derivados, queriendo brindar alternativas al turismo convencional. Sabemos que
    el turista ha de disfrutar un viaje que le permita vivir las experiencias propias del campo.`
  },
  {
    title: "Labor Social",
    icon: SupervisedUserCircle,
    description: `Establecemos alianzas con instituciones públicas y privadas en son de capacitar
    a los propietarios de Alojamientos Rurales en temas relacionados con buenas prácticas en la
    atención al turista. Además impulsamos la legalización de los Servicios Turísticos Rurales prestados.`
  }
];

export default corporateValuesList;



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/assets/corporateValuesList.js